import React, { useState, useEffect, useRef } from 'react';

export default function DecryptReveal({ text, isHovered, speed = 80, className = "" }) {
  const [displayText, setDisplayText] = useState(text);
  const intervalRef = useRef(null);
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@#$%&*+-=';

  const startScramble = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setDisplayText(() =>
        text
          .split('')
          .map((char) => {
            if (char === ' ') return ' ';
            return chars[Math.floor(Math.random() * chars.length)];
          })
          .join('')
      );
    }, speed);
  };

  useEffect(() => {
    if (!isHovered) {
      startScramble();
    } else {
      if (intervalRef.current) clearInterval(intervalRef.current);
      setDisplayText(text);
    }
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [text, isHovered]);

  return (
    <span className={className}>
      {displayText}
    </span>
  );
}
